// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper--_QAbb","card":"styles-module__card--CqkPH"};